export default __webpack_public_path__ + "static/written_response-94bab2b877f55e26bb2ee3bd3dd6d8fa.mp4";